// extracted by mini-css-extract-plugin
module.exports = {"poweredByWrapper":"style_poweredByWrapper__2DexM","poweredBy":"style_poweredBy__2HdxX","copyright":"style_copyright__2HrV6"};